import ApiService from "@/common/api/api.service";
import helpers from "@/common/utils/helpers";

const PessoaService = {
  listar(empresaId, porPagina = 0, pagina = 0) {
    return ApiService.get(`Pessoa?EmpresaId=${empresaId}&TamanhoDaPagina=${porPagina}&NumeroDaPagina=${pagina}`);
  },
  buscarPorId(id) {
    return ApiService.get(`Pessoa/${id}`);
  },
  salvar(form) {
    form.cnpj = helpers.removerMascara(form.cnpj);
    let result = [];
    if (!form.id) result = ApiService.post(`Pessoa`, { ...form });
    else result = ApiService.put(`Pessoa`, { ...form });
    return result;
  },
  excluir(id) {
    return ApiService.delete(`Pessoa?id=${id}`);
  },
  associarEmpresas(form) {
    return ApiService.put(`Pessoa/associar-empresas`, form);
  },
  atualizarMe(form){
    return ApiService.put(`Pessoa/pessoa-logada`, { ...form });
  },

  buscarHorasPessoa(empresaId, dataInicio, dataFim, pessoaId, ProjetoGestaoId, ProjetoPDId){
    return ApiService.get(`Equipe?empresaId=${empresaId}${!dataInicio ? `` : `&dataInicio=${dataInicio}`}${!dataFim ? `` : `&dataFim=${dataFim}`}${!pessoaId ? `` : `&pessoaId=${pessoaId}`}${!ProjetoGestaoId ? `` : `&ProjetoGestaoId=${ProjetoGestaoId}`}${!ProjetoPDId ? `` : `&ProjetoPDId=${ProjetoPDId}`}`);
  },
  buscarListaEquipe(empresaId, dataInicio, dataFim, pessoaId, ProjetoGestaoId, ProjetoPDId){
    return ApiService.get(`Equipe/pessoas?empresaId=${empresaId}${!dataInicio ? `` : `&dataInicio=${dataInicio}`}${!dataFim ? `` : `&dataFim=${dataFim}`}${!pessoaId ? `` : `&pessoaId=${pessoaId}`}${!ProjetoGestaoId ? `` : `&ProjetoGestaoId=${ProjetoGestaoId}`}${!ProjetoPDId ? `` : `&ProjetoPDId=${ProjetoPDId}`}`);
  },
  listarProjetos(empresaId){
    return ApiService.get(`Equipe/projetos?empresaId=${empresaId}`);
  }
};

export default PessoaService;
